import CustomersPage from "./CustomersPage";

export default CustomersPage;
